import aupMd from '../../../../public/aup.md';
import privacyMd from '../../../../public/privacy-policy.md';
import tosMd from '../../../../public/tos.md';

/**
 * Legal documents, bundled as text at build time.
 *
 * The routes in `app.routes.ts` identify each document by its filename in
 * `public/` (`data: { file: 'tos.md' }`), so the keys here mirror those names.
 * The raw `.md` files are deliberately NOT copied to `/assets` — serving them
 * alongside `/terms`, `/privacy` and `/aup` gave crawlers a duplicate of every
 * legal page.
 */
export const LEGAL_DOCUMENTS: Record<string, string> = {
  'aup.md': aupMd,
  'privacy-policy.md': privacyMd,
  'tos.md': tosMd,
};
